import React, { useEffect, useState } from "react";
import { Drawer, List, Typography, Badge, Avatar, Skeleton, Button, Tooltip, Space } from "antd";
import { BellOutlined, FullscreenOutlined, FullscreenExitOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { fetchNotifications, markNotificationRead } from "../../store/notificationsSlice";
import moment from "moment";
import "./NotificationDrawer.scss";

const { Text } = Typography;

// data.type values seen from the API: "PTP", "CALLBACK".
const TYPE_COLORS = {
  PTP: "purple",
  CALLBACK: "blue",
  REMINDER: "gold",
};

const NotificationDrawer = ({ visible, onClose }) => {
  const dispatch = useDispatch();
  const { notifications, loading } = useSelector((state) => state.notifications);
  const [isFullScreen, setIsFullScreen] = useState(false);

  useEffect(() => {
    if (visible) {
      dispatch(fetchNotifications());
    }
  }, [dispatch, visible]);

  const toggleFullScreen = () => setIsFullScreen(!isFullScreen);

  const handleRead = (item) => {
    if (item.is_read || item.id == null) return;
    dispatch(markNotificationRead(item.id));
  };

  return (
    <Drawer
      title={
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Space>
            <BellOutlined style={{ color: "#f2654a", fontSize: "20px" }} />
            <span>Notifications</span>
          </Space>
          <Tooltip title={isFullScreen ? "Exit Full Screen" : "Full Screen"}>
            <Button
              type="text"
              icon={isFullScreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
              onClick={toggleFullScreen}
            />
          </Tooltip>
        </div>
      }
      placement="right"
      onClose={onClose}
      open={visible}
      width={isFullScreen ? "100vw" : 400}
      className="notification-drawer"
    >
      {loading ? (
        <Skeleton active avatar paragraph={{ rows: 3 }} />
      ) : (
        <List
          itemLayout="horizontal"
          dataSource={notifications}
          locale={{ emptyText: "No new notifications" }}
          renderItem={(item) => (
            <List.Item
              className={`notification-item ${!item.is_read ? "unread" : ""}`}
              onClick={() => handleRead(item)}
            >
              <List.Item.Meta
                avatar={
                  <Badge dot={!item.is_read} color="#f2654a">
                    <Avatar style={{ backgroundColor: "#fff4f2", color: "#f2654a" }}>
                      {item.data?.type?.charAt(0) || "N"}
                    </Avatar>
                  </Badge>
                }
                title={
                  <div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
                    <Text strong>{item.title}</Text>
                    {item.created_at && (
                      <Tooltip title={moment(item.created_at).format("DD MMM YYYY, h:mm A")}>
                        <Text type="secondary" style={{ fontSize: "12px", whiteSpace: "nowrap" }}>
                          {moment(item.created_at).fromNow()}
                        </Text>
                      </Tooltip>
                    )}
                  </div>
                }
                description={
                  <div className="notification-desc">
                    <Text>{item.body}</Text>
                    {item.data?.type && (
                      <div className="notification-meta">
                        <Badge
                          color={TYPE_COLORS[item.data.type] || "default"}
                          text={item.data.type}
                        />
                      </div>
                    )}
                  </div>
                }
              />
            </List.Item>
          )}
        />
      )}
    </Drawer>
  );
};

export default NotificationDrawer;
